'use strict'
import axios from 'axios'

const setAuthRequest = config => {
    if(config.url == '/login') return config
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    config.headers.authorization = `Bearer ${user.TOKEN}`
    config.headers.userId = user.USUARIO_ID
    return config
}

const createHttp = ({ baseURL }) => {
    const http = axios.create({
        baseURL,
    })
    return http
}

export const request = createHttp({
    baseURL: process.env.VUE_APP_API_URL,
})

request.interceptors.request.use(setAuthRequest)